import { render, staticRenderFns } from "./addressInfo.vue?vue&type=template&id=5e4dda2d&scoped=true&"
import script from "./addressInfo.vue?vue&type=script&lang=js&"
export * from "./addressInfo.vue?vue&type=script&lang=js&"
import style0 from "./addressInfo.vue?vue&type=style&index=0&id=5e4dda2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4dda2d",
  null
  
)

export default component.exports